import { IAppModule, IServiceProvider } from './modules.types';
import { IDispatcher } from '../../packages/web/elements-types/src';
import { ContextProvider } from '../context-provider';
import { createRoutingService } from '../../_runtime/routing/router.service';
import { ScreenPropsProvider } from '@components-system';

export class RoutingModule implements IAppModule {
  name = 'routing';

  configureServices(serviceProvider: IServiceProvider): void {
    const dispatcher = serviceProvider.resolve<IDispatcher>('dispatcher');
    const contextProvider = new ContextProvider();
    dispatcher.registerNotificationHandler(
      'user-profile-changed',
      contextProvider
    );
    serviceProvider.register('context-provider', contextProvider);

    const routingService = createRoutingService();
    serviceProvider.register('screen-provider', new ScreenPropsProvider());
    serviceProvider.register('routing-service', routingService);
  }
}
